import React from 'react'
import classNames from 'classnames'

import style from './TmoCard.module.css'

function TmoCard({ className, children, customId, startIndex = 0 }) {
  return (
    <div
      id={customId}
      tabIndex={startIndex}
      className={classNames(style.container, className)}
    >
      {children}
    </div>
  )
}

export default TmoCard
